import { PersonalMessage } from 'pages/PersonalMessages/types'
import { getRequest } from 'utils/api/apiRequest'
import { WithPagination } from 'utils/api/pagination'

export const getPersonalMessages = (params = '') =>
  getRequest<WithPagination<PersonalMessage>>(`/user/messages?${params}`)

export const getHistoryPersonalMessages = (params = '') =>
  getRequest<WithPagination<PersonalMessage>>(`/user/messages/history?${params}`)
